// extracted by mini-css-extract-plugin
export default {"container":"style_container__NRjoC","contentWrapper":"style_contentWrapper__MARlb","subTitle":"style_subTitle__0ThxL"};